const IQVIA_TRIALS = ['NCT001IQVIA', 'NCT002IQVIA', 'NCT003IQVIA'];

export default IQVIA_TRIALS;
